<template>
  <div class="sidebar-wrapper">
    <div class="alert">
      {{message }}                          
    </div>
    <ul class="nav">
      <li class="nav-item active">
        <router-link class="nav-link" to="/dashboard">
          <p>Power</p>
          <i class="fa fa-bolt"></i>
        </router-link>
      </li>
      <li class="nav-item active">
        <router-link class="nav-link" to="/wallet">
          <p>Wallet</p>
          <i class="fa fa-money"></i>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  mounted () {
    var message = sessionStorage.getItem('message')
    if (message) {
      this.message = message
    }
  },
  data() {
    return {
      message: null
    }
  }
}
</script>
<style scoped>
.alert {
  font-size: 16px;
}
</style>